import { useState, useEffect, useRef } from 'react'
import ChartMenu, { MenuRow, MenuSwatch, MenuSelect, MenuNumber, MenuDivider, MenuActions, MenuButton } from './menu/ChartMenu'
import { SD_DEFAULTS } from './SDSubgraph'

// ============================================
// SDSettingsMenu — S/D (Supply/Demand) toolbar.
// AUTO-APPLY like DVP/CVD: every control commits on the spot.
// ============================================

const MODES = [
  { value: 'pulse', label: 'Pulse' },
  { value: 'run',   label: 'Running' },
]

export default function SDSettingsMenu({ show, x, y, openLeft, config, onUpdate, onHide, onClose }) {
  const [upCol, setUpCol] = useState(config?.upCol || SD_DEFAULTS.upCol)
  const [downCol, setDownCol] = useState(config?.downCol || SD_DEFAULTS.downCol)
  const [smoothLen, setSmoothLen] = useState(config?.smoothLen ?? SD_DEFAULTS.smoothLen)
  const [speedWeight, setSpeedWeight] = useState(config?.speedWeight ?? SD_DEFAULTS.speedWeight)
  const [mode, setMode] = useState(config?.mode || SD_DEFAULTS.mode)

  const wasShownRef = useRef(false)
  useEffect(() => {
    if (show && config && !wasShownRef.current) {
      setUpCol(config.upCol ?? SD_DEFAULTS.upCol)
      setDownCol(config.downCol ?? SD_DEFAULTS.downCol)
      setSmoothLen(config.smoothLen ?? SD_DEFAULTS.smoothLen)
      setSpeedWeight(config.speedWeight ?? SD_DEFAULTS.speedWeight)
      setMode(config.mode || SD_DEFAULTS.mode)
    }
    wasShownRef.current = !!show
  }, [show, config])

  const commit = (patch) => onUpdate(patch)
  const num = (key, set) => (n) => { set(n); commit({ [key]: n }) }

  if (!show) return null

  return (
    <ChartMenu anchor={{ x, y }} openLeft={openLeft} onClose={onClose}>
      <MenuRow>
        <MenuSwatch label="UP" value={upCol} onChange={c => { setUpCol(c); commit({ upCol: c }) }} />
        <MenuDivider />
        <MenuSwatch label="DN" value={downCol} onChange={c => { setDownCol(c); commit({ downCol: c }) }} />
        <MenuDivider />
        <MenuSelect value={mode} options={MODES}
          onChange={v => { setMode(v); commit({ mode: v }) }} />
      </MenuRow>
      <MenuRow>
        <MenuNumber label="EMA" value={smoothLen} min={1} max={100} width={44}
          onCommit={num('smoothLen', setSmoothLen)} />
        <MenuDivider />
        <MenuNumber label="SPEED" value={speedWeight} min={0} max={5} step={0.1} float width={44}
          onCommit={num('speedWeight', setSpeedWeight)} />
      </MenuRow>
      <MenuActions>
        <MenuButton variant="danger" onClick={() => { onHide(); onClose() }}>HIDE</MenuButton>
      </MenuActions>
    </ChartMenu>
  )
}
